import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaEventos from './TablaEventos';

const Eventos: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaEventos />
    </Box>
  );
};

export default Eventos;
